import axios from 'axios';

const getFornecedores = params => axios.get('/cotacoes', {
  params,
});

const create = data => axios.post('/detalhes-fornecedor', data);
const update = (id, data) => axios.put(`/detalhes-fornecedor/${id}`, data);
const updateEmail = (id, data) => axios.put(`/detalhes-fornecedor/${id}/emails`, data);
const updateWhatsapp = (id, data) => axios.put(`/detalhes-fornecedor/${id}/whatsapps`, data);
const remove = id => axios.delete(`/detalhes-fornecedor/${id}`);

const get = id => axios.get(`/detalhes-fornecedor/${id}`);
const list = params => axios.get('/detalhes-fornecedor', {
  params,
});

const getByFornecedor = id => axios.get(`detalhes-fornecedor/fornecedor/${id}`);

const getUsers = (idFornecedor, params) => axios.get(`fornecedor/${idFornecedor}/user/ativos`, {
  params,
});

const getDocumentos = idFornecedor => axios.get(`detalhes-fornecedor/${idFornecedor}/documento`, {
  params: {
    limit: 100,
  },
});

const saveDocumento = (idFornecedor, data) => {
  if (data.id) {
    return axios.put(`detalhes-fornecedor/${idFornecedor}/documento/${data.id}`, data);
  }
  return axios.post(`detalhes-fornecedor/${idFornecedor}/documento`, data);
};

const removeDocumento = (idFornecedor, idDocumento) => axios.delete(`detalhes-fornecedor/${idFornecedor}/documento/${idDocumento}`);

const updatePermiteEdicaoCotacao = payload => axios.put(`detalhes-fornecedor/${payload.id}/atualizar-edicao-cotacao`, payload);

const getFromCnpj = cnpj => axios.get(`fornecedores/gestao/cnpj/${cnpj}`);

const saveFornecedorGestao = payload => axios.post('fornecedores/gestao', payload);

export default {
  getFornecedores,
  create,
  update,
  updateEmail,
  updateWhatsapp,
  remove,
  get,
  getByFornecedor,
  list,
  getUsers,
  getDocumentos,
  saveDocumento,
  removeDocumento,
  updatePermiteEdicaoCotacao,
  getFromCnpj,
  saveFornecedorGestao,
};
